module.exports = __webpack_public_path__ + "static/media/Mask Group 160.4a4baad1.svg";